import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import ContentCopyIcon from '@mui/icons-material/FilterNone';

// components
import { InputAdornment, IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';

import TextField from './TextField';

const CopyField = (props) => {
  return (
    <TextField
      {...props}
      disabled
      inputProps={{
        classes: {
          input: props.classes.input,
        },
      }}
      endAdornment={
        <InputAdornment
          classes={{ root: props.classes.adornmentRoot }}
          position="end"
        >
          <CopyToClipboard text={props.value} onCopy={props.onCopy}>
            <IconButton size="large">
              <ContentCopyIcon />
            </IconButton>
          </CopyToClipboard>
        </InputAdornment>
      }
    />
  );
};

CopyField.defaultProps = {
  onCopy: () => {},
};

const styles = () => {
  return {
    input: {
      textOverflow: 'ellipsis',
      paddingRight: 40,
    },
  };
};

export default withStyles(styles)(CopyField);
